import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
  selector: 'app-blogs',
  standalone: true,
  imports: [MaterialModule, RouterLink],

  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
})
export class AppPrivacyPolicyComponent implements OnInit {
  constructor(
    public router: Router,
    public tenantService: TenantService,
  ) {}

  ngOnInit(): void {}
}
